import styled from 'styled-components';
import {
  screenSize,
  inputBorderColor,
  whiteColor,
  boldFont,
} from '@app/styles';

type Props = {
  type?: string;
  image?: any;
};
export const BackgroundContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: calc(100vh - 60px);
  width: 100%;
  margin-top: 60px;
  overflow: hidden;
  @media (${screenSize.tablet}) {
    display: block;
  }
`;
export const Container = styled.div`
  width: 100%;
  height: 100%;
  @media (${screenSize.tablet}) {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
  }
`;
export const SideNav = styled.div`
  height: 100%;
  width: 100%;
  overflow-y: hidden;
  overflow-x: hidden;
  background-color: #f4f5f7;
  @media (${screenSize.tablet}) {
    width: 330px;
    border-left: none;
    border-right: 1px solid ${inputBorderColor};
    border-bottom: 2px solid ${inputBorderColor};
  }
`;
export const DesktopSideNav = styled.div`
  display: none;
  @media (${screenSize.tablet}) {
    display: block;
  }
`;

export const ListView = styled.div`
  width: 100%;
  height: 100%;
  dispaly: flex;
  flex-direction: column;
  background-color: ${whiteColor};
  overflow-x: hidden;
  overflow-y: auto;
  @media (${screenSize.tablet}) {
    width: calc(100vw - 330px);
    height: 100%;
  }
`;

export const MainHeading = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 24px;
  color: #080707;
  ${boldFont}
  margin-top:18px;
  @media (${screenSize.tablet}) {
    margin-top: 0px;
  }
`;

export const DocumentContainer = styled.div`
  background: #eeeff3;
  border: 1px solid #e5e9ee;
  box-sizing: border-box;
  border-radius: 4px;
  margin: 8px;
  width: 100%;
  @media (${screenSize.maxMobile}) {
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
  }
  @media (${screenSize.tablet}) {
    width: 300px;
    margin: 16px 8px;
    height: 215px;
  }
`;

export const GridContainer = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 0px 16px 0px 0px;
  @media (${screenSize.tablet}) {
    flex-direction: row;
    flex-wrap: wrap;
    padding: 30px 24px 0px 24px;
  }
`;
export const InnerContainer = styled.div`
  @media (${screenSize.tablet}) {
    background: ${whiteColor};
  }
`;
export const Image = styled.img`
  display: block;
  margin-left: auto;
  margin-right: auto;
  padding: 16px 0px;

  opacity: 1;
  height: auto;
  transition: 0.5s ease;
  backface-visibility: hidden;
`;

export const DocumentProperty = styled.div`
  padding: 4px 16px;
  @media (${screenSize.tablet}) {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  ${({ type }: Props) => {
    if (type === 'title') {
      return `
    font-weight: 600;
    font-size: 16px;
    line-height: 21px;
    color: #202731;`;
    } else if (type === 'documentType') {
      return `
      font-weight: 600;
      font-size: 14px;
      line-height: 18px;
      color: #202731;
      opacity: 0.5;
      `;
    } else if (type === 'date') {
      return `
      font-size: 14px;
      line-height: 18px;
      color: #202731;
      opacity: 0.5;`;
    }
  }}
`;

export const ImageContainer = styled.div`
  @media (${screenSize.tablet}) {
    position: relative;
    path {
      fill: ${whiteColor};
    }
    &:hover {
      background: rgba(51, 51, 51, 0.9);
      img {
        opacity: 0.5;
      }
      .middle {
        opacity: 1.5;
      }
    }
  }
`;

export const Middle = styled.div`
  @media (${screenSize.maxMobile}) {
    padding: 16px;
    box-shadow: 0 11px 20px 0 rgba(47, 54, 65, 0.5);
    border-radius: 12px;
    position: absolute;
    top: 100px;
    z-index: 2;
    right: 16px;
    background: ${whiteColor};
  }
  @media (${screenSize.tablet}) {
    display: block;
    transition: 0.5s ease;
    opacity: 0;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    text-align: center;
  }
`;

export const Text = styled.div`
  font-weight: bold;
  font-size: 14px;
  line-height: 18px;
  color: #ffffff;
  margin-left: 4px;
  cursor: pointer;
  a {
    text-decoration: none;
    color: #202731;
  }
  color: #202731;
  @media (${screenSize.tablet}) {
    a {
      color: ${whiteColor};
    }
    color: ${whiteColor};
  }
`;
export const View = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  svg {
    width: 20px;
    height: 15px;
    @media (${screenSize.tablet}) {
      path {
        fill: ${whiteColor};
      }
    }
  }
`;
export const Download = styled.div`
  display: flex;
  align-items: center;
`;

export const Loader = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  @media (${screenSize.tablet}) {
    width: calc(100vw - 320px);
  }
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column-reverse;
  padding: 16px;
  @media (${screenSize.tablet}) {
    flex-direction: row;
    padding: 30px 40px 0px 40px;
    justify-content: space-between;
  }
`;

export const SeeMore = styled.div`
  text-align: center;
  margin-top: 32px;
  color: #202731;
  background: #ccc;
  padding: 8px;
  border-radius: 8px;
  margin: 32px auto;
  width: 150px;
  cursor: pointer;
`;

export const MobileFilterContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  @media (${screenSize.tablet}) {
    display: none;
  }
`;

export const DocInnerContainer = styled.div`
  @media (${screenSize.maxMobile}) {
    display: flex;
    align-items: center;
  }
`;

export const EllipsisIcon = styled.div`
  margin-right: 12px;
`;

export const NoDataText = styled.div`
  font-size: 20px;
  ${boldFont};
  color: black;
  opacity: 0.5;
`;

export const NoDataCard = styled.div`
  height: 70%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  @media (${screenSize.tablet}) {
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

export const MobileDropdown = styled.div`
  position: absolute;
  z-index: 2;
  top: 100px;
  right: 16px;
  background: white;
  padding: 16px;
`;
